
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "AliCaptcha",
  props: ["captchaConfig"],
  setup(props) {
    onMounted(() => {
      (
        window as unknown as { initAlicom4: (c: unknown, h: unknown) => void }
      ).initAlicom4(props.captchaConfig.config, props.captchaConfig.handler);
    });
  },
});
